import { Col, Container } from "react-grid-system";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../components/Button";
import { Unit } from "../../components/Unit";
import ArrowIcon from "../../assets/img/icons/arrow-prev.svg";
import CloseIcon from "../../assets/img/icons/close.svg";
import Bar from "../../components/Bar/Bar";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import { theme } from "../../styles/theme";
import { CloseBtn } from "../../components/CloseBtn";
import { getUnitList } from "../../api/organization-unit/organization-unit";
import { useAppContext, userUnits } from "../../context/appContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export default function UnitPage() {
	let { id } = useParams();
	const navigate = useNavigate();
	const { dispatch } = useAppContext();
	const { axiosPrivate } = useAxiosPrivate();
	const [isEditMode, setIsEditMode] = useState(false);

	useEffect(() => {
		loginHandler();
	}, []);

	const loginHandler = async () => {
		const units = await getUnitList(axiosPrivate);
		dispatch(userUnits(units));
	};

	return (
		<>
			{isEditMode ? (
				<>
					<Bar bg={theme.color.blue0} fullWidth infobar={true}>
						<Col>
							<p>Edit mode</p>
						</Col>
						<Col>
							<div className="d-flex justify-content-end">
								<CloseBtn onClick={() => setIsEditMode(false)} icon={CloseIcon} />
							</div>
						</Col>
					</Bar>
				</>
			) : (
				<Bar fullWidth>
					<Button onClick={() => navigate(-1)} bg={false} small icon={ArrowIcon}>
						Back
					</Button>
					<Breadcrumbs />
				</Bar>
			)}
			<Container>
				<Unit id={id} isEditMode={isEditMode} setIsEditMode={setIsEditMode} />
			</Container>
		</>
	);
}
